<template>
  <div class="d-flex flex-column layout">
    <NavbarHorizontal></NavbarHorizontal>
    <div class="row no-gutters d-flex flex-grow-1 position-relative flex-nowrap">
        <div class="col d-flex flex-column">
          <transition appear name="page-fade" :duration="{ enter: 200, leave: 400 }">
            <router-view></router-view>
          </transition>
        </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
  .layout {
    min-height: calc(100vh - 56px);
  }
</style>
<script>
import { NavbarHorizontal } from '../components';

export default {
  components: {
    NavbarHorizontal
  }
};
</script>